import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/noDataDark.png';
const _withScopeId = n => (_pushScopeId("data-v-435628f9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container",
  "element-loading-text": "设备导入中..."
};
const _hoisted_2 = {
  class: "top-container searchTop"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  key: 0,
  class: "button-container"
};
const _hoisted_5 = {
  key: 0,
  class: "image-preview-container"
};
const _hoisted_6 = {
  key: 0,
  class: "no-image-tip"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  key: 0,
  class: "dialog-footer"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "30px"
  }
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "el-upload__tip"
}, " 仅支持xlsx格式的文件 ", -1));
const _hoisted_12 = {
  class: "dialog-footer"
};
const _hoisted_13 = {
  class: "wellDrawerBody"
};
const _hoisted_14 = {
  key: 0,
  class: "runDataitem"
};
const _hoisted_15 = {
  class: "curTime"
};
const _hoisted_16 = {
  class: "raw-data-content"
};
const _hoisted_17 = {
  class: "raw-data-json"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "raw-data-indicator"
}, " 查看原始上报数据 ", -1));
const _hoisted_19 = {
  key: 2,
  class: "runDataitem"
};
const _hoisted_20 = {
  key: 0,
  class: "data-item-out"
};
const _hoisted_21 = {
  class: "data-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "电池电量", -1));
const _hoisted_23 = {
  class: "data-value"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_25 = [_hoisted_24];
const _hoisted_26 = {
  key: 1,
  class: "data-item"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "电池状态", -1));
const _hoisted_28 = {
  class: "data-value"
};
const _hoisted_29 = {
  key: 2,
  class: "data-item"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "液位状态", -1));
const _hoisted_31 = {
  class: "data-value"
};
const _hoisted_32 = {
  key: 3,
  class: "data-item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "配件状态", -1));
const _hoisted_34 = {
  class: "data-value"
};
const _hoisted_35 = {
  key: 4,
  class: "data-item"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "倾斜状态", -1));
const _hoisted_37 = {
  class: "data-value"
};
const _hoisted_38 = {
  key: 5,
  class: "data-item"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "压力状态", -1));
const _hoisted_40 = {
  class: "data-value"
};
const _hoisted_41 = {
  key: 6,
  class: "data-item"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "振动状态", -1));
const _hoisted_43 = {
  class: "data-value"
};
const _hoisted_44 = {
  key: 7,
  class: "data-item"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "温度", -1));
const _hoisted_46 = {
  class: "data-value"
};
const _hoisted_47 = {
  key: 8,
  class: "data-item"
};
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "湿度", -1));
const _hoisted_49 = {
  class: "data-value"
};
const _hoisted_50 = {
  key: 9,
  class: "data-item"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "压力值", -1));
const _hoisted_52 = {
  class: "data-value"
};
const _hoisted_53 = {
  key: 10,
  class: "data-item-out"
};
const _hoisted_54 = {
  class: "data-item"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号强度", -1));
const _hoisted_56 = {
  class: "data-value"
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_58 = [_hoisted_57];
const _hoisted_59 = {
  key: 11,
  class: "data-item"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信噪比", -1));
const _hoisted_61 = {
  class: "data-value"
};
const _hoisted_62 = {
  key: 12,
  class: "data-item"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "信号质量", -1));
const _hoisted_64 = {
  class: "data-value"
};
const _hoisted_65 = {
  key: 0,
  class: "data-item"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "激光模块编号：", -1));
const _hoisted_67 = {
  class: "data-value"
};
const _hoisted_68 = {
  key: 1,
  class: "data-item"
};
const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "平均浓度：", -1));
const _hoisted_70 = {
  class: "data-value"
};
const _hoisted_71 = {
  key: 2,
  class: "data-item"
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "最大浓度：", -1));
const _hoisted_73 = {
  class: "data-value"
};
const _hoisted_74 = {
  key: 3,
  class: "data-item"
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "数据数量：", -1));
const _hoisted_76 = {
  class: "data-value"
};
const _hoisted_77 = {
  key: 4,
  class: "data-item"
};
const _hoisted_78 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "控制数据：", -1));
const _hoisted_79 = {
  class: "data-value"
};
const _hoisted_80 = {
  key: 5,
  class: "data-item"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "状态数据：", -1));
const _hoisted_82 = {
  class: "data-value"
};
const _hoisted_83 = {
  key: 0,
  class: "data-item"
};
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "状态描述", -1));
const _hoisted_85 = {
  class: "data-value"
};
const _hoisted_86 = {
  key: 1,
  class: "data-item"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "气体类型描述", -1));
const _hoisted_88 = {
  class: "data-value"
};
const _hoisted_89 = {
  key: 2,
  class: "data-item-out"
};
const _hoisted_90 = {
  class: "data-item"
};
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "气体浓度", -1));
const _hoisted_92 = {
  class: "data-value"
};
const _hoisted_93 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-lishishuju"
}, null, -1));
const _hoisted_94 = [_hoisted_93];
const _hoisted_95 = {
  key: 0,
  class: "data-item"
};
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "供电状态描述：", -1));
const _hoisted_97 = {
  class: "data-value"
};
const _hoisted_98 = {
  key: 1,
  class: "data-item"
};
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "主电故障", -1));
const _hoisted_100 = {
  class: "data-value"
};
const _hoisted_101 = {
  key: 2,
  class: "data-item"
};
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "备电故障", -1));
const _hoisted_103 = {
  class: "data-value"
};
const _hoisted_104 = {
  key: 3,
  class: "data-item"
};
const _hoisted_105 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "充电故障", -1));
const _hoisted_106 = {
  class: "data-value"
};
const _hoisted_107 = {
  key: 4,
  class: "data-item"
};
const _hoisted_108 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "内部故障", -1));
const _hoisted_109 = {
  class: "data-value"
};
const _hoisted_110 = {
  key: 5,
  class: "data-item"
};
const _hoisted_111 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "回路1状态描述：", -1));
const _hoisted_112 = {
  class: "data-value"
};
const _hoisted_113 = {
  key: 6,
  class: "data-item"
};
const _hoisted_114 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "data-label"
}, "回路2状态描述：", -1));
const _hoisted_115 = {
  class: "data-value"
};
const _hoisted_116 = {
  key: 3,
  class: "no-data-container"
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-warning-outline"
})], -1));
const _hoisted_118 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-text"
}, "暂无运行数据", -1));
const _hoisted_119 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "no-data-desc"
}, "该设备当前没有上报运行数据", -1));
const _hoisted_120 = [_hoisted_117, _hoisted_118, _hoisted_119];
import { listAkxPage, addAkxPage, updateAkxPage, delAkxPge, importAkxPage, getAkxDetailData, getAkxOnlineData, exportAkxAllData } from '@/api/system1/tenant';
import { ref, unref, reactive, watch, onMounted, nextTick, computed } from 'vue';
import { downloadFlie, download } from '@/utils';
import { useStore } from 'vuex';
import { ElMessageBox, ElMessage } from 'element-plus';
import { useRoute } from "vue-router";
import DeviceStateHistory from "@/components/DeviceStateHistory.vue";
export default {
  __name: 'indexgd',
  setup(__props) {
    const route = useRoute();
    let deviceForm = ref(null);
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    //所属地区配置
    const cityProps = ref({
      label: 'name',
      value: 'id',
      multiple: false,
      checkStrictly: false
    });
    const showHistory = ref();
    const showDetailDialog = (indi, unit, name) => {
      let row = {
        id: "",
        indicator: indi,
        opstartTime: "",
        opEndTime: "",
        unit: unit,
        legend: name
      };
      showHistory.value.show(row, "历史数据");
    };
    const formatCode = function (code, column) {
      if (code == 0) {
        return '离线';
      } else if (code == 1) {
        return '在线';
      } else if (code == 2) {
        return '故障';
      } else {
        return '';
      }
    };
    const formatAlarmCode = function (code, column) {
      if (code) {
        return '告警';
      } else {
        return '正常';
      }
    };
    const formatCode1 = function (code, column) {
      if (code == 1) {
        return '已注册';
      } else {
        return '未注册';
      }
    };

    // 获取压力状态文本
    const getPressureStatusText = function (status) {
      switch (status) {
        case 0:
          return '正常';
        case 1:
          return '一级报警';
        case 2:
          return '二级报警';
        default:
          return '未知';
      }
    };

    // 获取压力状态样式类
    const getPressureStatusClass = function (status) {
      switch (status) {
        case 0:
          return 'status-normal';
        case 1:
          return 'status-warning';
        case 2:
          return 'status-error';
        default:
          return 'status-normal';
      }
    };

    // 从设备型号中提取四位数字编码
    const resolveDeviceTypeCode = deviceModel => {
      const supportedCodes = ['2531', '2532', '2536', '2626'];
      if (deviceModel) {
        const matches = deviceModel.match(/\d{4}/g);
        if (matches) {
          for (const code of matches) {
            if (supportedCodes.includes(code)) {
              return code;
            }
          }
        }
      }
      return '';
    };
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 0,
      dictLabel: '离线'
    }, {
      dictValue: 1,
      dictLabel: '在线'
    }, {
      dictValue: 2,
      dictLabel: '告警'
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      loading1: true,
      exportLoading: false,
      curId: "",
      onlineData: {
        batteryStatus: null,
        //电池状态(1=低电，0=正常)
        liquidLevelStatus: null,
        //液位状态(1=浸没，0=正常)
        accessoryStatus: null,
        // 配件状态(1=异常，0=正常)
        tiltStatus: null,
        //倾斜状态(1=异动，0=正常)
        pressureStatus: null,
        //压力状态(0=正常，1=一级报警，2=二级报警)
        vibrationStatus: null,
        // 振动状态(1=告警，0=正常)
        temperature: null,
        //温度
        humidity: null,
        //湿度
        pressureValue: null,
        //压力值
        rsrp: null,
        //信号强度
        snr: null,
        //信噪比
        csq: null,
        // 信号质量
        moduleNo: "",
        averageConcentration: "",
        maxConcentration: "",
        dataCount: "",
        controlData: "",
        statusData: "",
        probes: [{
          'address': null,
          'statusDesc': null,
          'gasTypeDesc': null,
          'concentration': null
        }],
        modules: [{
          output1Status: null,
          output2Status: null
        }],
        powerStatus: {
          statusDesc: null,
          mainPowerFault: null,
          //主电故障
          backupPowerFault: null,
          //备电故障
          chargeFault: null,
          //充电故障
          internalFault: null //内部故障
        }
      },
      dialogVisible: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 安可信台账表格数据
      roleList: [],
      // 弹出层标题
      title: '',
      uploadForm: {
        tenantId: null,
        fileList: []
      },
      uploadFormRules: {
        tenantId: [{
          required: true,
          message: '所属租户不能为空',
          trigger: 'change'
        }],
        fileList: [{
          required: true,
          message: '上传文件不能为空',
          trigger: 'blur'
        }]
      },
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      isDetail: false,
      // 日期范围
      dateRange: [],
      point: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        menuType: 4,
        //地埋式泄漏
        // vendorCode: '',
        deviceUuid: route.query.actNum || '',
        installLocation: '',
        deviceName: '',
        deviceNameCode: '',
        deviceStatus: null,
        order: "",
        prop: ""
      },
      showOnlineData: false,
      vendorList: [{
        label: "执行器",
        value: 1
      }, {
        label: "杭州先锋(AEP)",
        value: 2
      }, {
        label: "安可信",
        value: 3
      }, {
        label: "鑫豪斯",
        value: 4
      }, {
        label: "汉威",
        value: 5
      }, {
        label: "希尔得",
        value: 6
      }, {
        label: "场站",
        value: 99
      }, {
        label: "其它",
        value: 9
      }],
      // 表单参数
      form: {
        'tenantId': null,
        'deviceUuid': '',
        'devicePurpose': '',
        'vendorCode': '',
        'deviceNameCode': '',
        'deviceName': '',
        'deviceModel': '',
        'deviceStatus': '',
        'registerStatus': '',
        'probeCount': '',
        'moduleCount': '',
        'installLocation': '',
        'longitude': '',
        'latitude': '',
        'firmwareVersion': '',
        'softwareVersion': '',
        'clientIp': '',
        'clientPort': '',
        'remark': '',
        imgUrl: []
      },
      // 表单校验
      rules: {
        deviceUuid: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 20,
          message: '设备编号长度不能超过20个字符',
          trigger: 'blur'
        }],
        // vendorCode: [{ required: true, message: '不能为空', trigger: 'change' }],
        deviceNameCode: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 20,
          message: '设备名称编码长度不能超过20个字符',
          trigger: 'blur'
        }],
        deviceName: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 30,
          message: '设备名称长度不能超过30个字符',
          trigger: 'blur'
        }],
        deviceStatus: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        tenantId: [{
          required: true,
          message: '不能为空',
          trigger: 'change'
        }],
        installLocation: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }, {
          max: 50,
          message: '安装位置最多50个字符',
          trigger: 'blur'
        }],
        longitude: [{
          required: true,
          message: "经度不能为空",
          trigger: "blur"
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的经度数值"));
              return;
            }
            // 检查范围：-180 到 180
            if (numValue < -180 || numValue > 180) {
              callback(new Error("经度范围应在-180到180之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("经度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }],
        latitude: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback();
              return;
            }
            const numValue = parseFloat(value);
            // 检查是否为有效数字
            if (isNaN(numValue)) {
              callback(new Error("请输入有效的纬度数值"));
              return;
            }
            // 检查范围：-90 到 90
            if (numValue < -90 || numValue > 90) {
              callback(new Error("纬度范围应在-90到90之间"));
              return;
            }
            // 检查小数位最多20位
            const strValue = value.toString();
            const decimalIndex = strValue.indexOf('.');
            if (decimalIndex !== -1) {
              const decimalPart = strValue.substring(decimalIndex + 1);
              if (decimalPart.length > 20) {
                callback(new Error("纬度小数位最多20位"));
                return;
              }
            }
            callback();
          },
          trigger: "blur"
        }],
        remark: [{
          max: 200,
          message: '备注长度不能超过200个字符',
          trigger: 'blur'
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      deviceNameCode: null,
      searchFormData: [{
        prop: 'deviceUuid',
        label: '设备编号',
        placeholder: '设备编号',
        type: 'text',
        isSelect: false,
        span: 4
      },
      // {
      //   prop: "vendorCode",
      //   label: "厂商名称",
      //   placeholder: "请选择厂商名称",
      //   type: "list",
      //   span: 4,
      //   isSelect: false,
      //   filterable: true,
      //   options: [
      //     { label: "执行器", value: 1 },
      //     { label: "杭州先锋(AEP)", value: 2 },
      //     { label: "安可信", value: 3 },
      //     { label: "鑫豪斯", value: 4 },
      //     { label: "汉威", value: 5 },
      //     { label: "希尔得", value: 6 },
      //     { label: "场站", value: 99 },
      //     { label: "其它", value: 9 }
      //   ],
      //   props: { label: 'label', value: 'value' },
      // },
      // {
      //   prop: 'deviceNameCode',
      //   label: '设备名称编码',
      //   placeholder: '设备名称编码',
      //   type: 'text',
      //   isSelect: false,
      //   span: 4
      // },
      // {
      //   prop: 'deviceName',
      //   label: '设备名称',
      //   placeholder: '设备名称',
      //   type: 'text',
      //   isSelect: false,
      //   span: 4
      // },
      {
        prop: 'deviceStatus',
        label: '设备状态',
        placeholder: '请选择设备状态',
        type: 'list',
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: 'dictLabel',
          value: 'dictValue'
        },
        change: () => {},
        span: 4
      }, {
        prop: 'installLocation',
        label: '安装位置',
        placeholder: '请输入安装位置',
        type: 'text',
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: '搜索',
        type: 'primary',
        icon: 'el-icon-search',
        class: 'btn-liquid',
        handle: () => handleQuery()
      }, {
        label: '重置',
        icon: 'el-icon-refresh',
        class: 'commonDarkBtn',
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: '新增',
        buttonStyle: 'primary',
        hasPermi: ['akx:page:add'],
        className: 'addBtn',
        buttonIcon: 'Plus',
        exp: item => handleAdd(item)
      }, {
        buttonName: '删除',
        buttonStyle: 'danger',
        hasPermi: ['akx:page:del'],
        className: 'deleteBtn',
        buttonIcon: 'Delete',
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }, {
        buttonName: '导入',
        buttonStyle: 'primary',
        className: 'importBtn',
        buttonIcon: 'Download',
        hasPermi: ['akx:page:import'],
        exp: () => handleImport()
      }, {
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['akx:page:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }],
      deviceList: [],
      tableHeader: [{
        prop: 'deviceUuid',
        label: '设备编号',
        minWidth: 120
      },
      // {
      //   prop: 'vendorName',
      //   label: '厂商名称'
      // },
      // {
      //   prop: 'deviceNameCode',
      //   label: '设备名称编码',
      //   minWidth: 150
      // },
      // {
      //   prop: 'deviceName',
      //   label: '设备名称'
      // },
      // {
      //   prop: 'deviceModel',
      //   label: '型号'
      // },
      {
        prop: 'deviceStatus',
        label: '在线状态',
        formatData: formatCode,
        type: function (row) {
          if (row.deviceStatus == 2) {
            return 'error';
          } else if (row.deviceStatus == 1) {
            return 'success';
          } else if (row.deviceStatus == 0) {
            return 'info';
          } else {
            return 'error';
          }
        }
      }, {
        prop: "hasAlarm",
        label: "告警状态",
        formatData: formatAlarmCode,
        type: function (row) {
          if (row.hasAlarm) {
            return 'error';
          } else {
            return 'success';
          }
        }
      },
      // {
      //   prop: 'registerStatus',
      //   label: '注册状态',
      //   formatData: formatCode1,
      //   type: function (row) {
      //     if (row.actStatus == 0) {
      //       return 'info'
      //     } else if (row.actStatus == 1) {
      //       return 'success'
      //     }
      //   }
      // },
      //  {
      //   prop: "probeCount",
      //   label: "探头数量",
      // },{
      //   prop: "moduleCount",
      //   label: "模块数量",
      // },
      {
        prop: "attr1",
        label: "电池电量(%)",
        minWidth: 120,
        sort: true
      }, {
        prop: "attr2",
        label: "气体浓度(%LEL)",
        minWidth: 150,
        sort: true
      }, {
        prop: "attr3",
        label: "信号强度(dBm)",
        minWidth: 140,
        sort: true
      }, {
        prop: 'longitude',
        label: '经度',
        minWidth: 110
      }, {
        prop: 'latitude',
        label: '纬度',
        minWidth: 110
      }, {
        prop: 'installLocation',
        label: '安装位置',
        minWidth: 200
      },
      //{
      //   prop: "firmwareVersion",
      //   label: "固件版本",
      // },{
      //   prop: "softwareVersion",
      //   label: "软件版本",
      // },{
      //   prop: "firstRegisterTime",
      //   label: "首次注册时间",
      //   minWidth: 150,
      // },{
      //   prop: "lastOnlineTime",
      //   label: "最后在线时间",
      //    minWidth: 150,
      // },{
      //   prop: "lastReportTime",
      //   label: "最后上报时间",
      // },
      // {
      //   prop: 'remark',
      //   label: '备注'
      // },
      {
        prop: 'operation',
        label: '操作',
        width: '210px',
        fixed: 'right',
        operation: [{
          name: '查看',
          clickFun: row => handleDetail(row),
          hasPermi: []
        }, {
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['akx:page:edit']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['akx:page:del']
        }, {
          name: '运行数据',
          clickFun: row => handleView(row),
          hasPermi: ['akx:page:rundata'],
          showTooltip: true,
          tooltipContent: '查看原始上报数据'
        }]
      }]
    });
    // 计算属性：获取有效的图片列表（过滤空值并添加前缀）
    const getImageList = computed(() => {
      if (!state.form.imgUrl || !Array.isArray(state.form.imgUrl)) {
        return [];
      }
      const prefix = window.g?.imgUrlPrex || '';
      return state.form.imgUrl.filter(img => img && img.trim() !== '').map(img => {
        const imgUrl = img.trim();
        // 如果URL已经是完整路径（以http://或https://开头），则不添加前缀
        if (imgUrl.startsWith('http://') || imgUrl.startsWith('https://')) {
          return imgUrl;
        }
        // 否则添加前缀
        return prefix + imgUrl;
      });
    });
    onMounted(() => {
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    });
    const handleCityChange = function (val) {
      state.form.areaId = val[val.length - 1];
    };

    /** 查询安可信台账列表 */
    const getList = function () {
      state.loading = true;
      // 告警特殊处理
      let params = {
        ...state.queryParams
      };
      if (state.queryParams.deviceStatus == 2) {
        delete params.deviceStatus;
        params.hasAlarm = 1;
      }
      listAkxPage(params).then(response => {
        state.roleList = {
          rows: response.data.records,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };

    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        'tenantId': null,
        'valveCode': '',
        'valveName': '',
        'areaId': '',
        'location': '',
        'longitude': '',
        'latitude': '',
        'status': null
      };
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset = function () {
      state.form = {
        'tenantId': null,
        'deviceUuid': '',
        'deviceNameCode': '',
        'deviceName': '',
        'deviceModel': '',
        'deviceStatus': '',
        'vendorCode': '',
        'devicePurpose': '',
        'registerStatus': '',
        'probeCount': '',
        'moduleCount': '',
        'installLocation': '',
        'longitude': '',
        'latitude': '',
        'firmwareVersion': '',
        'softwareVersion': '',
        'clientIp': '',
        'clientPort': '',
        'remark': '',
        imgUrl: []
      };
      if (userType != 3) {
        state.uploadForm.tenantId = state.form.tenantId = window.localStorage.getItem("tenantId");
      }
    };
    // 排序
    const sortEvents = column => {
      state.queryParams.prop = column.prop;
      state.queryParams.order = column.order == 'ascending' ? 'asc' : 'desc';
      getList();
      console.log(column);
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        menuType: 4,
        //地埋式泄漏
        vendorCode: '',
        deviceUuid: '',
        installLocation: '',
        deviceName: '',
        deviceNameCode: '',
        deviceStatus: null,
        order: "",
        prop: ""
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.vendorDeviceId);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.isDetail = false;
      state.title = '添加台账';
      state.code = '';
      reset();
    };
    const clearValidate = prop => {
      deviceForm.value.clearValidate(prop);
    };

    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = '修改台账';
      state.isDetail = false;
      state.form.imgUrl = [];
      state.openDataScope = true;
      if (row.vendorDeviceId) {
        getAkxDetailData(row.vendorDeviceId).then(response => {
          if (response.code == 0) {
            state.form = {
              ...response.data
            };
            let imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
            state.form.imgUrl = imgList;
          } else {
            state.form = {
              ...row
            };
            let imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
            state.form.imgUrl = imgList;
          }
          state.form.vendorCode = row.vendorCode.toString();
          state.form.vendorDeviceId = row.vendorDeviceId;
        }).catch(() => {});
      }
    };
    const cicyCheck = function (val, point) {
      state.form.location = val;
      state.form.longitude = point.lng;
      state.form.latitude = point.lat;
    };
    /** 修改/新增安可信台账提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(deviceForm);
      formRef.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          if (state.form.imgUrl.length > 0) {
            params.imgUrl = state.form.imgUrl.join(',');
          } else {
            params.imgUrl = '';
          }
          params.deviceModel = "GT-AEC2532b";
          console.log(params, 'params---');
          if (state.form.id) {
            updateAkxPage(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('修改成功');
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addAkxPage(params).then(response => {
              if (response.code == 0) {
                ElMessage.success('新增成功');
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    // 导入
    const downloadTemplate = function () {
      downloadFlie('/ty-iot-manage/api/v1/ankexin/device/exportTemplate');
    };
    const handleImport = function () {
      state.uploadForm.fileList = [];
      state.dialogVisible = true;
    };
    const handleExport = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据项?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        let params = {
          ...state.queryParams
        };
        if (state.queryParams.deviceStatus == 2) {
          delete params.deviceStatus;
          params.hasAlarm = 1;
        }
        exportAkxAllData(params).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    const closeUpload = function () {
      state.dialogVisible = false;
    };
    const handleRemove = function () {
      const formRef = unref(deviceForm);
      state.uploadForm.fileList = [];
      formRef.validate();
    };
    const uploadRef = ref(null);
    const submitUpload = function (formEl) {
      const upload = unref(uploadRef);
      formEl.validate(valid => {
        if (valid) {
          upload.submit();
        }
      });
    };
    const ruleFormRef = ref(null);
    const uploadChange = function (file, list) {
      const formRef = unref(ruleFormRef);
      const fileName = file.name.split('.').pop().toLowerCase();
      if (!['xlsx'].includes(fileName)) {
        state.uploadForm.fileList = [];
        ElMessage.warning('文件类型只支持xlsx格式！');
        formRef.validate();
        return;
      }
      state.uploadForm.fileList = [file];
      formRef.validate();
    };
    const uploadFile = function (params) {
      state.exportLoading = true;
      let formData = new FormData();
      formData.append('file', params.file);
      if (state.uploadForm.tenantId && state.uploadForm.tenantId != 'null') {
        formData.append('tenantId', state.uploadForm.tenantId);
      }
      importAkxPage(formData).then(res => {
        state.saveLoading = false;
        state.exportLoading = false;
        state.dialogVisible = false;
        ElMessage.closeAll();
        if (res.code == 0) {
          if (res?.data?.code == 1001) {
            ElMessage.error(res?.data?.message);
          } else {
            ElMessage.success('导入成功！');
          }
          getList();
        } else {
          ElMessage.error(res.message);
        }
      }).catch(error => {
        ElMessage.closeAll();
        ElMessage.warning(error);
        state.saveLoading = false;
        state.exportLoading = false;
      });
    };
    const handleView = function (row) {
      // 优先从 deviceModel 提取四位数字型号，如果失败则使用原始 deviceNameCode
      const typeCode = resolveDeviceTypeCode(row.deviceModel);
      state.deviceNameCode = typeCode || row.deviceNameCode;
      state.loading1 = true;
      state.curId = row.id;
      getAkxOnlineData(row.deviceUuid).then(res => {
        if (res.data) {
          state.showOnlineData = true;
          state.onlineData = res.data;
        } else {
          state.showOnlineData = false;
        }
        state.loading1 = false;
        console.log(res.data, 'onlineData');
      });
      state.open = true;
    };
    const handleDetail = function (row) {
      state.title = '查看详情';
      state.isDetail = true;
      state.form.imgUrl = [];
      state.openDataScope = true;
      getAkxDetailData(row.vendorDeviceId).then(response => {
        if (response.code == 0) {
          state.form = {
            ...response.data
          };
          let imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
          state.form.imgUrl = imgList;
        } else {
          state.form = {
            ...row
          };
          let imgList = state.form.imgUrl ? state.form.imgUrl.split(',') : [];
          state.form.imgUrl = imgList;
        }
        state.form.vendorCode = row.vendorCode.toString();
        state.form.vendorDeviceId = row.vendorDeviceId;
      }).catch(() => {});
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const roleIds = row.vendorDeviceId || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // if(row.id){
        //   return deleteWell(roleIds);
        // }else{
        //   return delAkxPge(roleIds);
        // }
        return delAkxPge(roleIds);
      }).then(res => {
        getList();
        ElMessage.success('删除成功');
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_image = _resolveComponent("el-image");
      const _component_EIUploadMutiplePic = _resolveComponent("EIUploadMutiplePic");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, _ctx.form),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange,
        onSortEvents: sortEvents
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => state.openDataScope = $event),
        size: "550px",
        title: state.title,
        "close-on-click-modal": false,
        disabled: state.isDetail,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [!state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
          disabled: state.isDetail,
          model: state.form,
          "status-icon": "",
          "label-width": "120px",
          ref_key: "deviceForm",
          ref: deviceForm,
          rules: state.rules,
          class: "commonForm",
          "label-position": "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 15
          }, {
            default: _withCtx(() => [_unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "所属租户",
                prop: "tenantId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.tenantId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.form.tenantId = $event),
                  placeholder: "请选择所属租户"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.tenantName,
                      value: item.tenantId,
                      key: index
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备编号",
                prop: "deviceUuid"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceUuid,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.form.deviceUuid = $event),
                  placeholder: "请输入设备编号最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称编码",
                prop: "deviceNameCode"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceNameCode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => state.form.deviceNameCode = $event),
                  placeholder: "请输入设备名称编码最多20个字符",
                  maxlength: "20",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备名称",
                prop: "deviceName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.deviceName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.form.deviceName = $event),
                  placeholder: "请输入设备名称最多30个字符",
                  maxlength: "30",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备图片",
                prop: "imgUrl"
              }, {
                default: _withCtx(() => [state.isDetail ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getImageList), (img, index) => {
                  return _openBlock(), _createBlock(_component_el_image, {
                    key: index,
                    src: img,
                    "preview-src-list": _unref(getImageList),
                    "initial-index": index,
                    fit: "cover",
                    class: "preview-image",
                    "preview-teleported": true
                  }, null, 8, ["src", "preview-src-list", "initial-index"]);
                }), 128)), !_unref(getImageList) || _unref(getImageList).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)) : _createCommentVNode("", true)])) : (_openBlock(), _createBlock(_component_EIUploadMutiplePic, {
                  key: 1,
                  "file-list": state.form.imgUrl,
                  "onUpdate:fileList": _cache[5] || (_cache[5] = $event => state.form.imgUrl = $event),
                  limit: 3,
                  onClearValidate: _cache[6] || (_cache[6] = $event => clearValidate(state.form.imgUrl)),
                  uploadTip: "最多上传3张图片"
                }, null, 8, ["file-list"]))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备状态",
                prop: "deviceStatus"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.deviceStatus,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => state.form.deviceStatus = $event),
                  placeholder: "请选择设备状态"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "离线",
                    value: 0
                  }), _createVNode(_component_el_option, {
                    label: "在线",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "故障",
                    value: 2
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "注册状态",
                prop: "registerStatus"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: state.form.registerStatus,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => state.form.registerStatus = $event),
                  placeholder: "请选择注册状态"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "未注册",
                    value: 0
                  }), _createVNode(_component_el_option, {
                    label: "已注册",
                    value: 1
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "探头数量",
                prop: "probeCount"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.probeCount,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => state.form.probeCount = $event),
                  placeholder: "请输入探头数量"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "模块数量",
                prop: "moduleCount"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.moduleCount,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.form.moduleCount = $event),
                  placeholder: "请输入探头数量"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "安装位置",
                prop: "installLocation"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.installLocation,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => state.form.installLocation = $event),
                  placeholder: "请输入安装位置最多50个字符",
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "经度",
                prop: "longitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.longitude,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => state.form.longitude = $event),
                  placeholder: "请输入经度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "纬度",
                prop: "latitude"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.latitude,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => state.form.latitude = $event),
                  placeholder: "请输入纬度"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "固件版本",
                prop: "firmwareVersion"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.firmwareVersion,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => state.form.firmwareVersion = $event),
                  placeholder: "请输入固件版本"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "软件版本",
                prop: "softwareVersion"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.softwareVersion,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => state.form.softwareVersion = $event),
                  placeholder: "请输入软件版本"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), state.isDetail ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "首次注册时间",
                prop: "firstRegisterTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.firstRegisterTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => state.form.firstRegisterTime = $event),
                  placeholder: "请输入首次注册时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), state.isDetail ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "最后在线时间",
                prop: "lastOnlineTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.lastOnlineTime,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => state.form.lastOnlineTime = $event),
                  placeholder: "请输入最后在线时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), state.isDetail ? (_openBlock(), _createBlock(_component_el_col, {
              key: 3,
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "最后上报时间",
                prop: "lastReportTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.lastReportTime,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => state.form.lastReportTime = $event),
                  placeholder: "请输入最后上报时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: state.form.remark,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => state.form.remark = $event),
                  placeholder: "请输入备注最多200个字符",
                  maxlength: "200",
                  "show-word-limit": "",
                  type: "textarea",
                  rows: 3
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled", "model", "rules"])])]),
        _: 1
      }, 8, ["modelValue", "title", "disabled"]), _createVNode(_component_commonDrawer, {
        title: "导入设备",
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => state.dialogVisible = $event),
        width: "500px",
        "close-on-click-modal": false,
        "before-close": closeUpload
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[22] || (_cache[22] = $event => submitUpload(ruleFormRef.value))
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: closeUpload
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          "auto-upload": false,
          model: state.uploadForm,
          rules: state.uploadFormRules,
          "status-icon": "",
          "label-width": "120px",
          class: "commonForm"
        }, {
          default: _withCtx(() => [_hoisted_10, _unref(userType) == 3 ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属租户",
              prop: "tenantId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: state.uploadForm.tenantId,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => state.uploadForm.tenantId = $event),
                placeholder: "请选择所属租户"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantInfos), (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.tenantName,
                    value: item.tenantId,
                    key: index
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "模板"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: downloadTemplate
            }, {
              default: _withCtx(() => [_createTextVNode("下载模板")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文件",
            prop: "fileList"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_upload, {
              ref_key: "uploadRef",
              ref: uploadRef,
              "auto-upload": false,
              class: "upload-demo",
              action: "",
              "on-remove": handleRemove,
              "file-list": state.uploadForm.fileList,
              "on-change": uploadChange,
              "http-request": uploadFile
            }, {
              tip: _withCtx(() => [_hoisted_11]),
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode("上传文件")]),
                _: 1
              })]),
              _: 1
            }, 8, ["file-list"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => state.open = $event),
        size: "600px",
        title: "运行数据",
        "close-on-click-modal": false,
        onClose: cancel,
        class: "wellDrawer"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [state.showOnlineData ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, "最近一次上报时间：" + _toDisplayString(state.onlineData.timestamp), 1)])) : _createCommentVNode("", true), state.showOnlineData ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 1,
          placement: "bottom",
          trigger: "click",
          "show-after": 0,
          "hide-after": 0,
          width: 400,
          effect: "light",
          "popper-class": "raw-data-tooltip"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("pre", _hoisted_17, _toDisplayString(JSON.stringify(state.onlineData, null, 2)), 1)])]),
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        })) : _createCommentVNode("", true), state.showOnlineData ? (_openBlock(), _createElementBlock("div", _hoisted_19, [state.onlineData?.batteryVoltage !== null ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, _toDisplayString(state.onlineData?.batteryPercentage) + "%", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[24] || (_cache[24] = $event => showDetailDialog('attr1', '%', '电池电量'))
        }, _hoisted_25)])) : _createCommentVNode("", true), state.onlineData?.batteryStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createElementVNode("span", _hoisted_28, _toDisplayString(state.onlineData?.batteryStatus === 1 ? '低电' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.liquidLevelStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_hoisted_30, _createElementVNode("span", _hoisted_31, _toDisplayString(state.onlineData?.liquidLevelStatus === 1 ? '浸没' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.accessoryStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createElementVNode("span", _hoisted_34, _toDisplayString(state.onlineData?.accessoryStatus === 1 ? '异常' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.tiltStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_hoisted_36, _createElementVNode("span", _hoisted_37, _toDisplayString(state.onlineData?.tiltStatus === 1 ? '异动' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.pressureStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_hoisted_39, _createElementVNode("span", _hoisted_40, _toDisplayString(getPressureStatusText(state.onlineData?.pressureStatus)), 1)])) : _createCommentVNode("", true), state.onlineData?.vibrationStatus !== null ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_hoisted_42, _createElementVNode("span", _hoisted_43, _toDisplayString(state.onlineData?.vibrationStatus === 1 ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.temperature !== null ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_hoisted_45, _createElementVNode("span", _hoisted_46, _toDisplayString(state.onlineData?.temperature) + "°C", 1)])) : _createCommentVNode("", true), state.onlineData?.humidity !== null ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_hoisted_48, _createElementVNode("span", _hoisted_49, _toDisplayString(state.onlineData?.humidity) + "%", 1)])) : _createCommentVNode("", true), state.onlineData?.pressureValue !== null ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_hoisted_51, _createElementVNode("span", _hoisted_52, _toDisplayString(state.onlineData?.pressureValue) + "Pa", 1)])) : _createCommentVNode("", true), state.onlineData?.csq !== null ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("span", _hoisted_56, _toDisplayString(state.onlineData?.csq) + "dBm", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[25] || (_cache[25] = $event => showDetailDialog('attr3', 'dBm', '信号强度'))
        }, _hoisted_58)])) : _createCommentVNode("", true), state.onlineData?.snr !== null ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, _createElementVNode("span", _hoisted_61, _toDisplayString(state.onlineData?.snr) + "dB", 1)])) : _createCommentVNode("", true), state.onlineData?.csq !== null ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_hoisted_63, _createElementVNode("span", _hoisted_64, _toDisplayString(state.onlineData?.csq), 1)])) : _createCommentVNode("", true), state.deviceNameCode == '2536' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 13
        }, [state.onlineData?.moduleNo !== null ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_hoisted_66, _createElementVNode("span", _hoisted_67, _toDisplayString(state.onlineData?.moduleNo), 1)])) : _createCommentVNode("", true), state.onlineData?.averageConcentration !== null ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_hoisted_69, _createElementVNode("span", _hoisted_70, _toDisplayString(state.onlineData?.averageConcentration) + " ppm", 1)])) : _createCommentVNode("", true), state.onlineData?.maxConcentration !== null ? (_openBlock(), _createElementBlock("div", _hoisted_71, [_hoisted_72, _createElementVNode("span", _hoisted_73, _toDisplayString(state.onlineData?.maxConcentration) + " ppm", 1)])) : _createCommentVNode("", true), state.onlineData?.dataCount !== null ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_hoisted_75, _createElementVNode("span", _hoisted_76, _toDisplayString(state.onlineData?.dataCount), 1)])) : _createCommentVNode("", true), state.onlineData?.controlData !== null ? (_openBlock(), _createElementBlock("div", _hoisted_77, [_hoisted_78, _createElementVNode("span", _hoisted_79, _toDisplayString(state.onlineData?.controlData), 1)])) : _createCommentVNode("", true), state.onlineData?.statusData !== null ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_hoisted_81, _createElementVNode("span", _hoisted_82, _toDisplayString(state.onlineData?.statusData), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), state.deviceNameCode == '2531' || state.deviceNameCode == '2532' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 14
        }, [state.onlineData?.probes[0]?.statusDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_hoisted_84, _createElementVNode("span", _hoisted_85, _toDisplayString(state.onlineData?.probes[0]?.statusDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.probes[0]?.gasTypeDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_hoisted_87, _createElementVNode("span", _hoisted_88, _toDisplayString(state.onlineData?.probes[0]?.gasTypeDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.concentration !== null ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_hoisted_91, _createElementVNode("span", _hoisted_92, _toDisplayString(state.onlineData?.probes[0]?.concentration) + "%LEL", 1)]), _createElementVNode("span", {
          class: "indicator",
          onClick: _cache[26] || (_cache[26] = $event => showDetailDialog('attr2', '%LEL', '气体浓度'))
        }, _hoisted_94)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), state.deviceNameCode == '2626' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 15
        }, [state.onlineData?.powerStatus?.statusDesc !== null ? (_openBlock(), _createElementBlock("div", _hoisted_95, [_hoisted_96, _createElementVNode("span", _hoisted_97, _toDisplayString(state.onlineData?.powerStatus?.statusDesc), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.mainPowerFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_98, [_hoisted_99, _createElementVNode("span", _hoisted_100, _toDisplayString(state.onlineData?.powerStatus?.mainPowerFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.backupPowerFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_101, [_hoisted_102, _createElementVNode("span", _hoisted_103, _toDisplayString(state.onlineData?.powerStatus?.backupPowerFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.chargeFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_104, [_hoisted_105, _createElementVNode("span", _hoisted_106, _toDisplayString(state.onlineData?.powerStatus?.chargeFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.powerStatus?.internalFault !== null ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_hoisted_108, _createElementVNode("span", _hoisted_109, _toDisplayString(state.onlineData?.powerStatus?.internalFault ? '告警' : '正常'), 1)])) : _createCommentVNode("", true), state.onlineData?.modules?.length > 0 && state.onlineData?.modules[0]?.output1Status !== null ? (_openBlock(), _createElementBlock("div", _hoisted_110, [_hoisted_111, _createElementVNode("span", _hoisted_112, _toDisplayString(state.onlineData?.modules[0]?.output1Status), 1)])) : _createCommentVNode("", true), state.onlineData?.modules?.length > 0 && state.onlineData?.modules[0]?.output2Status !== null ? (_openBlock(), _createElementBlock("div", _hoisted_113, [_hoisted_114, _createElementVNode("span", _hoisted_115, _toDisplayString(state.onlineData?.modules[0]?.output2Status), 1)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_116, _hoisted_120))])), [[_directive_loading, state.loading1]])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(DeviceStateHistory, {
        ref_key: "showHistory",
        ref: showHistory,
        id: state.curId
      }, null, 8, ["id"])])), [[_directive_loading, state.exportLoading]]);
    };
  }
};